<template>
  <b-modal
    id="modal-new-patient"
    no-close-on-backdrop
    no-close-on-esc
    ref="modal"
    hide-footer
    @ok="handleOk"
    @show="clear"
    data-cy="modal-paciente-new"
  >
    <template slot="modal-title">
      <h5 data-cy="modal-paciente-new-titulo">Novo Paciente</h5>
    </template>

    <template slot="default" slot-scope="{ ok, cancel }">
      <b-form
        ref="form"
        @submit.prevent="console.log(1)"
        data-cy="form-paciente-new"
      >
        <div class="mb-2" data-cy="paciente-new-alerta">
          <b-alert
            show
            variant="warning"
            dismissible
            data-cy="alerta-pagamento-titular"
          >
            <b>Atenção:</b> Para pagamentos com
            <i><b>cartão de crédito ou boleto</b></i> é obrigatório o
            preenchimento do CPF nos dados do Titular.
          </b-alert>
        </div>
        <div class="mb-2" data-cy="paciente-new-campo-nome">
          <label for="nome" v-required data-cy="label-nome">
            Nome {{ temNomeSocial ? "Social" : "" }}
          </label>
          <b-form-input
            class="form-control"
            type="text"
            ref="nome"
            :state="validateStatePaciente('name')"
            v-model="$v.name.$model"
            id="nome"
            data-cy="campo-paciente-new-nome"
          />
        </div>
        <div class="mb-2" data-cy="paciente-new-campo-nome-social">
          <div class="form-group" data-cy="paciente-new-switch-nome-social">
            <label class="switch" data-cy="switch-nome-social">
              <input
                type="checkbox"
                id="checkbox"
                v-model="temNomeSocial"
                v-on:change="!temNomeSocial ? (nomeCivil = null) : ''"
                data-cy="checkbox-nome-social"
              />
              <span class="slider round" data-cy="slider-nome-social"></span>
            </label>
            <span data-cy="texto-nome-social"> Indicar que é nome social.</span>
          </div>
        </div>
        <div
          class="mb-2"
          v-show="temNomeSocial"
          data-cy="paciente-new-campo-nome-civil"
        >
          <label for="nomeCivil" v-required data-cy="label-nome-civil">
            Nome Civil
          </label>
          <b-form-input
            class="form-control"
            type="text"
            ref="nomeCivil"
            :state="validateStatePaciente('nomeCivil')"
            v-model.trim="$v.nomeCivil.$model"
            id="nomeCivil"
            data-cy="campo-paciente-new-nome-civil"
          />
        </div>
        <div class="mb-2" data-cy="paciente-new-campo-nascimento">
          <label
            for="datanascimento"
            v-required
            data-cy="label-data-nascimento"
          >
            Data de Nascimento
          </label>
          <b-form-input
            class="form-control"
            :state="validateStatePaciente('birthDate')"
            v-model="$v.birthDate.$model"
            id="datanascimento"
            ref="datanascimento"
            :maxlength="10"
            placeholder="dd/mm/aaaa"
            v-mask="[`##/##/####`]"
            data-cy="campo-paciente-new-data-nascimento"
          />
        </div>
        <div class="mb-2" data-cy="paciente-new-campo-sexo">
          <label for="sexo" v-required data-cy="label-sexo">
            Sexo
          </label>
          <b-form-select
            v-model="gender"
            :options="genders"
            id="sexo"
            ref="sexo"
            data-cy="campo-paciente-new-sexo"
          />
        </div>
        <div class="mb-2" data-cy="paciente-new-campo-telefone">
          <label for="telefone" v-required data-cy="label-telefone">
            Telefone
          </label>
          <b-form-input
            class="form-control"
            type="tel"
            ref="telefoneprincipal"
            :state="validateStatePaciente('phone')"
            v-model="$v.phone.$model"
            id="telefone"
            v-mask="[`(##) ####-####`, `(##) #####-####`]"
            data-cy="campo-paciente-new-telefone"
          />
        </div>

        <b-form-group
          id="fieldset-2"
          label="Documento"
          label-for="input-2"
          data-cy="paciente-new-grupo-documento"
        >
          <b-form-select
            required
            v-model="documentType"
            :options="documentTypes"
            ref="documento"
            id="input-2"
            data-cy="campo-paciente-new-tipo-documento"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          id="fieldset-3"
          label="Número"
          label-for="input-3"
          data-cy="paciente-new-grupo-numero-documento"
        >
          <b-form-input
            :state="validateStatePacienteDocumento('documentNumber')"
            class="form-control"
            type="tel"
            id="input-3"
            v-mask="
              documentType === 'CPF' ? '###.###.###-##' : 'XXXXXXXXXXXXXXXXXXXX'
            "
            ref="numerodocumento"
            v-model="$v.documentNumber.$model"
            data-cy="campo-paciente-new-numero-documento"
          />
          <div class="invalid-feedback" data-cy="erro-cpf-invalido">
            CPF inválido.
          </div>
        </b-form-group>
        <b-form-group
          id="fieldset-5"
          label="Email"
          label-for="input-5"
          data-cy="paciente-new-grupo-email"
        >
          <b-form-input
            class="form-control"
            type="email"
            :state="validateStatePaciente('email')"
            v-model="$v.email.$model"
            id="input-5"
            data-cy="campo-paciente-new-email"
          />
        </b-form-group>
        <div
          class="w-100 d-flex justify-content-between"
          data-cy="paciente-new-botoes"
        >
          <b-button
            variant="white"
            class="btn-outline-primary rounded-0"
            @click="cancel()"
            data-cy="btn-paciente-new-cancelar"
          >
            <strong>Cancelar</strong>
          </b-button>
          <b-button
            type="default"
            variant="primary"
            class="rounded-0"
            @click="ok()"
            data-cy="btn-paciente-new-salvar"
          >
            <strong>Salvar</strong>
          </b-button>
        </div>
      </b-form>
    </template>
  </b-modal>
</template>

<script>
import { documentTypes, genders, validCPF } from "@/core/enumHelper";
import { mask } from "vue-the-mask";
import moment from "moment";
import {
  email,
  maxLength,
  minLength,
  required,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  name: "paciente-new",
  directives: { mask },
  data() {
    return {
      validate: false,
      birthDate: null,
      documentNumber: null,
      documentType: documentTypes.CPF,
      email: null,
      name: null,
      nomeCivil: null,
      temNomeSocial: false,
      phone: null,
      gender: genders.INDEFINIDO
    };
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    },
    phone: {
      required,
      minLength: minLength(14),
      maxLength: maxLength(15)
    },
    nomeCivil: {
      required: requiredIf(function(pacienteModel) {
        return pacienteModel.temNomeSocial;
      }),
      minLength: minLength(4)
    },
    email: {
      required,
      email
    },
    birthDate: {
      required,
      minLength: minLength(10),
      maxValue(val) {
        val = moment(val, "DD/MM/YYYY");
        return moment(val) < moment();
      }
    },
    documentNumber: {
      isCpf(val) {
        if (this.documentType === "CPF" && val !== "" && val !== null) {
          if (!validCPF(val.replace(/[^0-9]/g, ""))) {
            return false;
          }
        }
        return true;
      }
    }
  },
  computed: {
    documentTypes() {
      return Object.values(documentTypes);
    },
    genders() {
      return Object.values(genders);
    }
  },
  methods: {
    clear() {
      (this.validate = false),
        (this.birthDate = null),
        (this.documentNumber = null),
        (this.documentType = documentTypes.CPF),
        (this.email = null),
        (this.name = null),
        (this.nomeCivil = null),
        (this.phone = null),
        (this.gender = genders.INDEFINIDO);
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    validateStatePaciente(val) {
      const { $dirty, $error } = this.$v[val];
      return $dirty ? !$error : null;
    },
    validateStatePacienteDocumento(val) {
      const { $dirty, $error } = this.$v[val];
      if (this.$v[val].$model === "") {
        return;
      }
      return $dirty ? !$error : null;
    },
    validateStatePoliticas() {
      const { $dirty, $error } = this.$v.aceitaPoliticas;
      return $dirty ? !$error : null;
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$v.name.$touch();
      this.$v.phone.$touch();
      this.$v.nomeCivil.$touch();
      this.$v.email.$touch();
      this.$v.birthDate.$touch();
      if (this.$v.$anyError) {
        return;
      }

      let payload = {
        url: this.$serverHost,
        patient: {
          id: Date.now(),
          dependente: true,
          dataNascimento: this.birthDate.replace(
            /(..)\/(..)\/(....)/,
            "$3-$2-$1 23:59"
          ),
          numeroDocumento: this.documentNumber,
          tipoDocumento: this.documentType,
          email: this.email,
          nome: this.name,
          nomeCivil: this.nomeCivil,
          telefonePrincipal: this.phone,
          sexo: this.gender
        }
      };

      this.$store
        .dispatch("new_patient", payload)
        .then(data => {
          this.validate = false;
          this.birthDate = null;
          this.documentNumber = null;
          this.documentType = documentTypes.CPF;
          this.email = null;
          this.name = null;
          this.nomeCivil = null;
          this.phone = null;
          this.gender = genders.INDEFINIDO;
          this.$nextTick(() => {
            this.$refs["modal"].hide();
          });
        })
        .catch(error => {
          if (error.response.status === 409) {
            this.$bvToast.toast(error.response.data.message, {
              title: "Problema no cadastro",
              autoHideDelay: 10000,
              variant: "danger"
            });
            this.$store.commit("remove_patient", payload);
            this.$refs["documento"].focus();
            this.validation.documento = false;
          } else {
            this.$bvToast.toast(
              "Houve um problema no cadastro, por favor entrar em contato com o suporte",
              {
                title: "Problema no cadastro",
                autoHideDelay: 10000,
                variant: "danger"
              }
            );
            this.$store.commit("remove_patient", payload);
            this.$nextTick(() => {
              this.$refs["modal"].hide();
            });
            console.error(error);
          }
        });
    }
  }
};
</script>

<style></style>
